"use client";
import { ReviewBadge } from "../../design1/components/Testimonials";
import React from "react";
import Pagination from "../components/Pagination";

import { TestimonialsType } from "../../../constants/testimonialsData";
import { GroupHeader } from "../../../ui/Headers";
import { useTestimonialsCarousel } from "src/app/lib/useTestimonials";
import Image from "next/image";
import { capitalizeWords } from "src/app/components/utils";
const Testimonials = () => {
  const {
    emblaRef,
    selectedIndex,
    scrollSnaps,
    emblaApi,
    onDotButtonClick,
    testimonials,
  } = useTestimonialsCarousel();

  if (testimonials?.length === 0) return null;
  return (
    <section className="py-8 pb-[9rem]  overflow-hidden">
      <div className="wrapper">
        <GroupHeader
          max={1200}
          subheader="Hear firsthand experiences from our satisfied clients as they share how our services helped them achieve their real estate goals."
          header="What Our Clients Are Saying"
        />
        <div ref={emblaRef} className="items gap-4 ">
          <div className="parent flex">
            {testimonials?.map((item, index) => {
              return (
                <div
                  key={index}
                  className=" w-[max(33%,400px)] xs:w-[100%] pr-8 select-none flex justify-center shrink-0"
                >
                  <TestimonialsCard key={index} {...item} />
                </div>
              );
            })}
          </div>
        </div>

        <div className="pagination mt-16">
          <Pagination
            scrollSnaps={scrollSnaps}
            selectedIndex={selectedIndex}
            onDotButtonClick={onDotButtonClick}
            emblaApi={emblaApi}
          />
        </div>
      </div>
    </section>
  );
};
export default Testimonials;

const TestimonialsCard: React.FC<TestimonialsType> = ({
  image,
  name,
  comment,
  reviewType,
}) => {
  return (
    <div
      style={{
        boxShadow: "0px 2px 25px 0px rgba(33, 33, 33, 0.08)",
      }}
      className="bg-white flex p-8 items-center rounded-2xl flex-col gap-1 justify-between"
    >
      <div className="flex-col items-center flex gap-3">
        <Image
          height={112}
          width={112}
          src={image as string}
          alt=""
          className="block bg-[rgba(var(--primary-color-rgb),0.7)]  object-cover size-[7rem] rounded-full"
        />
        <blockquote className="text-center h6">{comment}</blockquote>
      </div>
      <div className="item items-center flex-col flex gap-3">
        <h4 className="font-medium capitalize">{capitalizeWords(name)}</h4>
        <ReviewBadge
          headerAs="h5"
          className="text-[1.4rem]"
          flag={true}
          reviewType={reviewType}
        />
      </div>
    </div>
  );
};
